/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_LabelInputs */

const en_marketing_engagement_label = /** @type {(inputs: Marketing_Engagement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With an engagement`)
};

const es_marketing_engagement_label = /** @type {(inputs: Marketing_Engagement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con una colaboración`)
};

const fr_marketing_engagement_label = /** @type {(inputs: Marketing_Engagement_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec une mission`)
};

/**
* | output |
* | --- |
* | "With an engagement" |
*
* @param {Marketing_Engagement_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_label = /** @type {((inputs?: Marketing_Engagement_LabelInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_LabelInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_label(inputs)
	if (locale === "es") return es_marketing_engagement_label(inputs)
	return fr_marketing_engagement_label(inputs)
});